import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ModuleGroup } from './module-group';

export class ModuleGroupStateModel extends EntityStateModel<ModuleGroup> {}
